module.exports = __webpack_public_path__ + "img/img-4.f20c7e97.webp";